enum PageNames {
  PAYMENT_BOOTSTRAP = 'PAYMENT_BOOTSTRAP',
  PAYMENT_BOOTSTRAP_LIGHT = 'PAYMENT_BOOTSTRAP_LIGHT',
  PAYMENT_BOOTSTRAP_EXPRESS = 'PAYMENT_BOOTSTRAP_EXPRESS',
  PAYMENT_SUCCESS = 'PAYMENT_SUCCESS',
  PAYMENT_FAILURE = 'PAYMENT_FAILURE',
  PAYMENT_CANCEL = 'PAYMENT_CANCEL',
  PAYMENT_ERROR = 'PAYMENT_ERROR',
  PAYMENT_NOT_FOUND = 'PAYMENT_NOT_FOUND',
  PAYMENT_MANUAL_IDENTIFICATION = 'PAYMENT_MANUAL_IDENTIFICATION',
  PAYMENT_MANUAL_IDENTIFICATION_CONSUMER = 'PAYMENT_MANUAL_IDENTIFICATION_CONSUMER',
  DISTRIBUTION_PAYMENT = 'DISTRIBUTION_PAYMENT',
  DISTRIBUTION_PAYMENT_REDESIGN = 'DISTRIBUTION_PAYMENT_REDESIGN',
  DISTRIBUTION_PAYMENT_ERROR = 'DISTRIBUTION_PAYMENT_ERROR',
  CAMPAIGN_NOT_FOUND = 'CAMPAIGN_NOT_FOUND',
  CHECKIN_NOT_FOUND = 'CHECKIN_NOT_FOUND',
  ELIGIBILITY_PRE_ASSESSMENT = 'ELIGIBILITY_PRE_ASSESSMENT',
  ELIGIBILITY_ASSESSMENT = 'ELIGIBILITY_ASSESSMENT',
  ELIGIBILITY_SUCCESS = 'ELIGIBILITY_SUCCESS',
  ELIGIBILITY_FAILURE = 'ELIGIBILITY_FAILURE',
  ELIGIBILITY_ERROR = 'ELIGIBILITY_ERROR',
  ADDRESS_BOOTSTRAP = 'ADDRESS_BOOTSTRAP',
  ADDRESS_SUCCESS = 'ADDRESS_SUCCESS',
  ADDRESS_ERROR = 'ADDRESS_ERROR',
  BLOCKED_SESSION_SHARING = 'BLOCKED_SESSION_SHARING',
  GENERIC_ERROR = 'GENERIC_ERROR',
  INSTANT_SHOPPING_BOOTSTRAP = 'INSTANT_SHOPPING_BOOTSTRAP',
  INSTANT_SHOPPING_SUCCESS = 'INSTANT_SHOPPING_SUCCESS',
  INSTANT_SHOPPING_FAILURE = 'INSTANT_SHOPPING_FAILURE',
  INSTANT_SHOPPING_CANCEL = 'INSTANT_SHOPPING_CANCEL',
  INSTANT_SHOPPING_ERROR = 'INSTANT_SHOPPING_ERROR',
  TOKEN_SIGNUP_BOOTSTRAP = 'TOKEN_SIGNUP_BOOTSTRAP',
  SHOPPING_WALLET_BOOTSTRAP = 'SHOPPING_WALLET_BOOTSTRAP',
  SHOPPING_WALLET_BOOTSTRAP_SINGLE_STEP = 'SHOPPING_WALLET_BOOTSTRAP_SINGLE_STEP',
  SHOPPING_WALLET_BOOTSTRAP_STEPS = 'SHOPPING_WALLET_BOOTSTRAP_STEPS',
  IN_STORE_TOKENS_BOOTSTRAP = 'IN_STORE_TOKENS_BOOTSTRAP',
  IST_BOOTSTRAP = 'IST_BOOTSTRAP',
  IST_AUTHENTICATION = 'IST_AUTHENTICATION',
  IST_ERROR = 'IST_ERROR',
  IST_SIGNUP_SUCCESS = 'IST_SIGNUP_SUCCESS',
  IST_DEMO_TOOL = 'IST_DEMO_TOOL',
  STATIC_QR_DEMO = 'STATIC_QR_DEMO',
  QR_EXPIRED = 'QR_EXPIRED'
}

export default PageNames
